import React from "react";
import {FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectChangeEvent} from "@mui/material";
import {EEquipmentType, equipmentsTranslateKey} from "../../../models/utils/EEquipmentType";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    equipmentType?: EEquipmentType,
    setEquipmentType: (equipmentType: EEquipmentType) => void,
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 16/05/2022
 * @last_update 16/05/2022
 **/
class SelectEquipmentType extends React.Component<Props> {

    state = {
        isError: false,
    }

    render() {

        /**
* Retrieves from the props the function to access the translation.
**/
const getTranslation = this.props.t;

        /**
         * Return the helper text to display depending on the error status.
         * @returns {string} The correct helper text.
         */
        const getHelperText = (): string => {
            let helperText: string;
            if(this.state.isError) {
                helperText = getTranslation("steps.select.equipment.input-error");
            } else {
                helperText = getTranslation("steps.select.equipment.helper");
            }
            return helperText;
        }

        /**
         * Function called when the input is changing.
         * Checks the data filled in. If they are correct, report them to the parent component. Displays the adapted error otherwise.
         * @param {SelectChangeEvent<string>} event
         */
        const onFieldChange = (event: SelectChangeEvent<number | string>) => {
            const equipmentType = event.target.value;
            if(equipmentType in EEquipmentType) {
                this.setState({isError: false});
                this.props.setEquipmentType(equipmentType as EEquipmentType);
            } else {
                this.setState({isError: true});
            }
        }

        return (

            <FormControl fullWidth>
                <InputLabel id="select-equipment-label">{getTranslation("steps.select.equipment.label")} *</InputLabel>
                <Select
                    labelId="select-equipment-label"
                    id="select-equipment-input"
                    value={this.props.equipmentType !== undefined ? this.props.equipmentType : ''}
                    label={getTranslation("steps.select.equipment.label")}
                    error={this.state.isError}
                    onChange={onFieldChange}
                    required
                    fullWidth
                >
                    {
                        equipmentsTranslateKey.map((equipment: string, index: number) => (
                            <MenuItem key={index} value={index}>{getTranslation(equipment)}</MenuItem>
                        ))
                    }
                </Select>
                <FormHelperText>{getHelperText()}</FormHelperText>
            </FormControl>

        );

    };

}

export default withTranslation()(SelectEquipmentType);
